// extracted by mini-css-extract-plugin
var _1 = "Label_button__jn337";
var _2 = "Label_wrapper__lvYZv";
var _3 = "Label_wrapperCard__k9w2s";
var _4 = "Label_wrapperCardModal__zFUVJ";
var _5 = "Label_wrapperHoverable__XAg6I";
var _6 = "Label_wrapperLabels__3rHIj";
var _7 = "Label_wrapperRemovable__xk2gc";
export { _1 as "button", _2 as "wrapper", _3 as "wrapperCard", _4 as "wrapperCardModal", _5 as "wrapperHoverable", _6 as "wrapperLabels", _7 as "wrapperRemovable" }
